<template>
<div class="leCafe">
  <div >
    <img src="/img/le_cafe.png">
  </div>
  <div v-html="leCafeMarkup.html" />
</div>
</template>
<script>
export default {
  name: 'MenuFull',
  props: {
    leCafeMarkup: Object
  },
}
</script>
